module.exports = __webpack_public_path__ + "static/media/1_WEB_DES_Vue-Nord.7f79b021.png";